//Use sham when history is not supported
function doNothing() {}

export default (window.Feature && window.Feature.detected.history
    ? window.history
    : {
          replaceState: doNothing,
          pushState: doNothing,
          state: doNothing,
          go: window.history.go,
          forward: window.history.forward,
          back: window.history.back
      });



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/history.js